// extracted by mini-css-extract-plugin
export default {"app":"App_app__MG4dE","root":"App_root__QSJ6K"};